import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import DashboardNavbar from "./DashboardNavbar.jsx";
import FileList from "./Filelist.jsx";
import Sidebar from './sidebar.jsx';
import SignIn from "./Loginpg.jsx";
import AudioList from "../Admin/audioList.jsx";
import PostQuestion from "../Admin/postQuestion.jsx"
import TeacherDashboard from "../Admin/admindashbrd.jsx";
import { UserProvider } from "./UserContext.jsx";
import Studentinfo from "../Admin/studentdashbrd.jsx";
import Dashboard from "../Admin/studentdashbrd.jsx";
import Doubts from './Doubts.jsx';
import Analytics from './studentAnalytics.jsx';

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    return Boolean(token && user && localStorage.getItem('isAuthenticated') === 'true');
  });
  
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPath, setCurrentPath] = useState(() => {
    return sessionStorage.getItem('currentPath') || '/';
  });

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('token');
      const user = localStorage.getItem('user');
      const isAuth = localStorage.getItem('isAuthenticated') === 'true';
      setIsAuthenticated(Boolean(token && user && isAuth));
      setIsLoading(false);
    };

    checkAuth();
    window.addEventListener('storage', checkAuth);

    // Save current path to sessionStorage
    const path = window.location.pathname;
    if (path && path !== '/login') {
      sessionStorage.setItem('currentPath', path);
      setCurrentPath(path);
    }

    return () => {
      window.removeEventListener('storage', checkAuth);
    };
  }, []);

  const handleLogin = (status, userData) => {
    if (status && userData) {
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('token', userData.token);
      localStorage.setItem('user', JSON.stringify(userData.user));
      const savedPath = sessionStorage.getItem('currentPath') || '/';
      setCurrentPath(savedPath);
    }
    setIsAuthenticated(status);
  };

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    sessionStorage.removeItem('currentPath');
    setIsAuthenticated(false);
    setCurrentPath('/');
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  if (isLoading) {
    return <div className="loading-container">Loading...</div>;
  }

  return (
    <UserProvider>
      <Router>
        {isAuthenticated ? (
          <div className={`app-container ${isSidebarOpen ? 'sidebar-active' : ''}`}>
            <Sidebar 
              isOpen={isSidebarOpen} 
              onToggle={toggleSidebar}
              onLogout={handleLogout}
            />
            <div className="main-content">
              <Routes>
                <Route path="/" element={<DashboardNavbar />} />
                <Route path="/learn" element={<FileList />} />
                <Route path="/doubts" element={<Doubts />} />
                <Route path="/analytics" element={<Analytics />} />
                <Route path="/login" element={<Navigate to={currentPath} replace />} />
                <Route path="*" element={<Navigate to={currentPath} replace />} />
              </Routes>
            </div>
          </div>
        ) : (
          <Routes>
            <Route path="/login" element={<SignIn onLogin={handleLogin} />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        )}
      </Router>
    </UserProvider>
  );
}

